export enum PlasticBagsForPackagingFields {
  type = "type",
  length = "length",
  width = "width",
  folding = "folding",
  material = "material",
  thickness = "thickness",
  mainColor = "mainColor",
  otherMainColor = "otherMainColor",
  numberOfPrintColorsFirstSide = "numberOfPrintColorsFirstSide",
  firstSidePrintArea = "firstSidePrintArea",
  numberOfPrintColorsSecondSide = "numberOfPrintColorsSecondSide",
  secondSidePrintArea = "secondSidePrintArea",
  designFile = "designFile",
  amountPcs = "amountPcs",
}
